import requester from '@/utils/request'
export default {
  openRobot: () => requester.post('/chat/auto-reply/v1/open', {}, { headers: { isSeller: true } }),
  closeRobot: () => requester.post('/chat/auto-reply/v1/close', {}, { headers: { isSeller: true } }),
  updateRobot(params: any) {
    return requester.post('/user/basic/v1/ai-character-design/update', params, { headers: { isSeller: true } })
  },
  getRobotStatus() {
    return requester.post('/chat/auto-reply/v1/info', {}, { headers: { isSeller: true } })
  },
}
